export default "__VITE_PUBLIC_ASSET__5d4533b3__"